<template>
  <v-form ref="form">

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="stateId"
          label="Estado"
          :items="extraData.globalContext.allStates"
          item-value="id"
          item-text="name"
          @input="stateSelected"
          autocomplete="new"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          :disabled="stateId ? readOnly : true"
          v-model="entry.cityId"
          v-bind="getObject('cityId')"
          label="Cidade"
          :items="citiesList"
          item-value="id"
          item-text="name"
          :loading="citiesListLoading"
          @input="entry.city = citiesList.find(obj => obj.id == entry.cityId)"
          autocomplete="new"
        />
      </v-col>

      <v-col cols="12" sm="12">
        <v-text-field
          v-model="entry.street"
          v-bind="getObject('street')"
          label="Rua"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="2" sm="2">
        <v-checkbox label="S/N" v-model="addrNumber"></v-checkbox>
      </v-col>

      <v-col cols="10" sm="10">
        <MaskedTextField
          v-bind="getObject('number')"
          :inputData.sync="entry.number"
          mask-type="number_only"
          label="Número"
          autocomplete="off"
          :key="numberKey+'_key'"
          :disabled="readOnly || addrNumber"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field
          v-model="entry.neighborhood"
          v-bind="getObject('neighborhood')"
          label="Bairro"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-bind="getObject('postalCode')"
          :inputData.sync="entry.postalCode"
          mask-type="cep"
          label="CEP"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="entry.complement"
          v-bind="getObject('complement')"
          label="Complemento"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      citiesListLoading: false,
      citiesList: [],
      stateId: null,
      pageLoading: false,
      addrNumber: false,
      numberKey: 0,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    DateField: DateField,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    
    if (this.entry.city) {
      this.stateId = this.entry.city.state.id;
      this.stateSelected();
      console.log("number", this.entry.number);
      if(this.entry.number && this.entry.number != "S/N"){
        console.log("tem number");
      }else{
        this.addrNumber=true;
        this.entry.number = "";
      }
    }
  },
  mounted() {
  },
  computed: {
  },
  watch: {
    addrNumber: function(newValue, oldValue){
      // console.log(newValue);
      if(newValue){
        this.entry.number = null;
        this.numberKey++;
      }
    },
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    stateSelected: function() {
      this.citiesListLoading = true;
      this.$apollo
        .query({
          query: ALL_CITIES_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            stateId: this.stateId
          }
        })
        .then(response => {
          // console.log("cities", response.data, this.entry);
          this.citiesList = response.data.globalContext.allStateCities;

          if (this.entry.city) {
            this.entry.cityId = this.entry.city.id;
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.citiesListLoading = false));
    },
  }
};
const ALL_CITIES_QUERY = gql `
  query ($stateId: ID!) {
    globalContext {
      allStateCities(stateId: $stateId) {
        id
        name
        state {
          id
          name
          shortName
        }
      }
    }
  }
`;
</script>

<style scoped></style>
